import { useUser } from '@myosh/myosh-login';
import { memo } from 'react';
import { Navigate, Outlet } from 'react-router';
import { ThemeProvider } from '@/context/theme.context';

function PrivateRoute() {
  const { state } = useUser();
  const { auth: isAuthenticated, loginStatus } = state;

  if (isAuthenticated && loginStatus === 'done') {
    return (
      <ThemeProvider>
        <Outlet />
      </ThemeProvider>
    );
  } else if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return null;
}

export default memo(PrivateRoute);
